import type { DashboardSummary } from '../dashboardTypes';
import { DASH, formatMoney } from '../format';

/** The summary cards (SRS 13). Every figure is the server's; a figure the server cannot yet work out (Processing Window Closed) is a dash, never a made-up zero. */
export function SummaryCards({ summary, loading }: { summary: DashboardSummary | null; loading: boolean }) {
  const count = (n: number | null | undefined) => (loading || n === null || n === undefined ? DASH : String(n));
  return (
    <div className="tpd-cards" data-testid="summary-cards" aria-busy={loading}>
      <div className="tpd-card tpd-card--total">
        <span className="tpd-card__value" data-testid="total-amount-due">{loading ? DASH : formatMoney(summary?.totalAmountDue)}</span>
        <span className="tpd-card__label">Total Amount Due</span>
        <span className="tpd-card__note">Open, unpaid liabilities</span>
      </div>
      <div className="tpd-cards__group">
        <div className="tpd-card tpd-card--attention">
          <span className="tpd-card__value" data-testid="card-needs-attention">{count(summary?.failedNeedsAttention)}</span>
          <span className="tpd-card__label">Needs Attention</span>
          <span className="tpd-card__note">Failed, insufficient funds, review or overdue</span>
        </div>
        <div className="tpd-card tpd-card--pending">
          <span className="tpd-card__value" data-testid="card-pending">{count(summary?.pendingPayments)}</span>
          <span className="tpd-card__label">Pending Payments</span>
          <span className="tpd-card__note">Awaiting processing</span>
        </div>
        <div className="tpd-card tpd-card--processing">
          <span className="tpd-card__value" data-testid="card-processing">{count(summary?.processing)}</span>
          <span className="tpd-card__label">Processing</span>
          <span className="tpd-card__note">In progress with partner</span>
        </div>
        <div className="tpd-card tpd-card--window">
          <span className="tpd-card__value" data-testid="card-window-closed">{count(summary?.processingDeadlinesPassed)}</span>
          <span className="tpd-card__label">Processing Window Closed</span>
          <span className="tpd-card__note">{summary && summary.processingDeadlinesPassed === null ? 'Not available yet' : 'Unpaid past the processing deadline'}</span>
        </div>
      </div>
    </div>
  );
}
